export const SKIPED = -1;
export const PLACED = 0;
export const VERIFIED = 1;
export const REGISTRY_READY = 994;
export const IN_PROGRESS = 2;
export const FINISH = 3;
export const ERROR = 4;
export const CANCELED = 5;
export const WAIT_OTP = 6;
export const WAIT_CONFIRMATION = 7;
export const BILL = 8;
export const WAIT_USER_REGISTRATION = 9;
export const NEED_TO_CHECK = 20;
export const TIMEOUT_CANCEL = 51;
export const WAIT_CVV = 61;
export const WAIT_SUPPORT_CONFIRMATION = 71;
export const REPAY = 74;

export const REGISTRY_COMPLETED = 993;
